import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMerchantAuth } from '../../../contexts/AuthContext';
import StaffTab from './StaffTab';

/**
 * Renders StaffTab if user has view_staff, otherwise redirects to roles (if view_roles) or dashboard.
 */
export default function StaffIndex() {
    const { hasPermission } = useMerchantAuth();
    if (hasPermission('view_staff')) {
        return <StaffTab />;
    }
    if (hasPermission('view_roles')) {
        return <Navigate to="/dashboard/staff/roles" replace />;
    }
    return <Navigate to="/dashboard" replace />;
}
